module.exports = __webpack_public_path__ + "images/38cce9097f76da97e1992676db71607e81ff38b5afa045d42fe43ff64d1c996f.svg";